var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-comments" },
    [
      _c(
        "app-timeline",
        _vm._l(_vm.comments, function(comment, index) {
          return _c(
            "app-timeline-item",
            { key: index, attrs: { variant: "primary" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                },
                [
                  _c("h6", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(comment.comentario))
                  ]),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm._f("dateFormatTime")(comment.fecha)))
                  ])
                ]
              ),
              _c("p", { staticClass: "mb-2" }, [
                _vm._v(" " + _vm._s(comment.nombre) + " ")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-sm-row flex-column justify-content-between align-items-start"
                },
                [
                  comment.documentos
                    ? _c("div", { staticClass: "mb-1 mb-sm-0" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex mr-1 color-primary" },
                          _vm._l(comment.documentos, function(
                            attachment,
                            index
                          ) {
                            return _c("DownloadFile", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.right",
                                  value: "" + attachment.nombre,
                                  expression: "`${attachment.nombre}`",
                                  modifiers: { hover: true, right: true }
                                }
                              ],
                              key: index,
                              staticClass: "pill-info-attach",
                              attrs: {
                                mood: "compact",
                                path: attachment.adjuntoUrl,
                                name: attachment.nombre,
                                "version-id": attachment.versionId
                              }
                            })
                          }),
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }